export const sizes = {
  appBarHeight: '72px',
  navbarWidth: '72px',
  subnavWidth: '250px',
} as const;
